import { form } from '../../../formState'
import * as OrderTexts from '../../../intl'

const POD_NOTES_MAX_LENGTH = 512

export function PodNotes() {
  form.useAddFieldValidation('formPods.note', (field, _formApi) => {
    const value = field.value
    if (value?.length > POD_NOTES_MAX_LENGTH) {
      return OrderTexts.getValidationPodNotes(POD_NOTES_MAX_LENGTH)
    }
  })

  return <form.TextField testId="notes" name="formPods.note" label={OrderTexts.getNoteLabel()} />
}
